import { initForms, setupKenticoValidation } from '@chrisjwarnes/form-validator/src'
import { addWebTrackingToForms } from './validation/web-tracking'
import { addGoogleAnalyticsTrackingToForms } from './validation/google-analytics'
import { setupFileUpload } from './file-upload'

function setupWebForms () {
  setupKenticoValidation()
  addWebTrackingToForms()
  addGoogleAnalyticsTrackingToForms()
  initForms()
  setupFileUpload(document)
}

export {
  setupWebForms
}
